import {en} from "./translations.en";
import {fr} from "./translations.fr";

export const translations = {
  en: {
    resetPassword: en,
  },
  fr: {
    resetPassword: fr,
  },
};
